import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BrochureForm = ({ onSuccess, brochureUrl }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateMobile = (mobile) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(mobile);
  };

  const downloadBrochure = () => {
    if (!brochureUrl) {
      alert("Brochure is Downloaded.");
      return;
    }

    // Open in new tab (reliable for S3 links)
    const link = document.createElement("a");
    link.href = brochureUrl;
    link.target = "_blank";

    // Optional: ask browser to treat as download (may be ignored for some cross-origin URLs)
    link.setAttribute("download", "");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!validateMobile(formData.mobile)) {
      alert("Please enter a valid 10 digits mobile number.");
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/home/contact`, formData);

      // Clear form
      setFormData({ name: "", email: "", mobile: "", message: "" });

      // Trigger brochure download
      downloadBrochure();

      // Optional callback, e.g. to close popup
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto">
      {/* Title */}
      <div className="mb-4 sm:mb-6 text-center">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">
          Let&apos;s connect
        </h2>
        <p className="mt-1 text-xs sm:text-sm text-gray-600">
          Share your details to instantly access the brochure and get a quick call from our team.
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Full name"
          required
          className="w-full border rounded-lg px-3 py-2.5 text-xs sm:text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none"
        />

        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          required
          className="w-full border rounded-lg px-3 py-2.5 text-xs sm:text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none"
        />

        <input
          name="mobile"
          value={formData.mobile}
          onChange={handleChange}
          placeholder="Mobile number"
          required
          className="w-full border rounded-lg px-3 py-2.5 text-xs sm:text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none"
        />

        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Tell us what you’re looking for"
          rows="3"
          required
          className="w-full border rounded-lg px-3 py-2.5 text-xs sm:text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none resize-none"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2.5 sm:py-3 rounded-lg font-semibold text-sm sm:text-base hover:bg-blue-700 transition disabled:opacity-70 disabled:cursor-not-allowed"
        >
          {loading ? "Processing..." : "Submit & Download Brochure"}
        </button>
      </form>
    </div>
  );
};

export default BrochureForm;
